<template>
  <v-container fluid class="pa-8">
    <h2 class="text-h4 font-weight-bold mb-6">
      New/Edit Patent Docket
    </h2>

    <div class="pl-4 pr-4">
      <v-tabs
        v-model="tabselect"
        color="#55638E"
        class="custom-tabs"
        style="border-bottom: 1px solid #E0E0E0;"
      >
        <v-tab>Internal Work</v-tab>
        <v-tab>Internal Timeline</v-tab>
      </v-tabs>
    </div>
    <div v-if="tabselect == 0" class="mt-4 pl-4 pr-4">
      <v-card class="pa-10">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <h3><span class="red--text">* </span>Object Type</h3>
              <v-autocomplete
                v-model="itemdata.objecttype"
                :items="objecttype_list"
                item-text="objecttype_code"
                item-value="objecttype_id"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3><span class="red--text">* </span>Work Type</h3>
              <v-autocomplete
                v-model="itemdata.doctype"
                :items="documenttype_ptlist_search"
                item-text="documenttype_code"
                item-value="documenttype_id"
                outlined
                dense
                @input="
                  () => {
                    if (itemdata.refno == '' || itemdata.refno == null) {
                      $nextTick(() => {
                        itemdata.doctype = 0;
                      });
                      $store.state.global_dialog = true;
                      setupAlertDialog(
                        true,
                        'Check data',
                        'Put File NO',
                        'text-h5 red--text text-center',
                      );
                      return;
                    }
                    // calDateFinalDeadline();
                    checktypeFunction();
                  }
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3><span class="red--text">* </span>File No.</h3>
              <v-text-field
                class="widthsizesearch heightsizesearch"
                outlined
                dense
                disabled
                background-color="#F5F5F5"
                v-on:keyup.enter="onSearchfile_no(itemdata.refno)"
                @blur="onSearchfile_no(itemdata.refno)"
                v-model="itemdata.refno"
              ></v-text-field>
              <h4 class="red--text">* input text and enter for search</h4>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Application No.</h3>
              <v-text-field
                v-model="app_noshow"
                disabled
                background-color="#F5F5F5"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mth">
            <v-col cols="12" sm="3" md="3">
              <h3>Client Name</h3>
              <v-textarea
                v-model="itemdata.trademark_name"
                outlined
                dense
                disabled
                auto-grow
                rows="1"
                class="no-resize-textarea"
                background-color="#F5F5F5"
              />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Agent Name</h3>
              <v-text-field
                v-model="agent_contact_name"
                outlined
                dense
                disabled
                background-color="#F5F5F5"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Associate Name</h3>
              <v-text-field
                v-model="associate_contact_name"
                outlined
                dense
                disabled
                background-color="#F5F5F5"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Doc Type</h3>
              <v-autocomplete
                v-model="doctype_actions_select"
                :items="doctype_actions_tlist"
                item-text="name"
                item-value="id"
                multiple
                chips
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8" md="8">
              <v-row align="start">
                <v-col cols="4" sm="4" md="4">
                  <h3>Upload Notice File(s)</h3>
                  <input
                    type="file"
                    accept="application/pdf,image/png,image/jpeg"
                    multiple="multiple"
                    @change="previewMultiFile"
                    ref="noticefile"
                    style="display: none"
                  />
                  <v-btn
                    :style="{
                      backgroundColor: '#254E58',
                      color: 'white',
                    }"
                    @click="$refs.noticefile.click()"
                    class="widthbtnnoticefile"
                    elevation="7"
                  >
                    <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                    >Upload</v-btn
                  >
                </v-col>
                <v-col cols="8" sm="8" md="8" class="mt-10">
                  <div v-if="this.filenamenotice.length > 0">
                    <v-row
                      v-for="(item, index) in filenamenotice"
                      :key="index"
                      style="padding-left: 70px"
                    >
                      <span
                        @click="previewnoticefilepdf(index)"
                        class="file-link"
                      >
                        {{ item }}
                      </span>
                      <v-btn
                        icon
                        color="red"
                        @click="confirmdeletenoticefile(index)"
                        style="margin-top: -7px"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row align="start">
                <v-col cols="4" sm="4" md="4">
                  <h3>Upload Submitted File(s)</h3>
                  <input
                    type="file"
                    accept="application/pdf,image/png,image/jpeg"
                    multiple="multiple"
                    @change="previewMultiAttachFile"
                    ref="attachfile"
                    style="display: none"
                  />
                  <v-btn
                    :style="{
                      backgroundColor: '#254E58',
                      color: 'white',
                    }"
                    @click="$refs.attachfile.click()"
                    class="widthbtnnoticefile"
                    elevation="7"
                  >
                    <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                    >Upload</v-btn
                  >
                </v-col>
                <v-col cols="8" sm="8" md="8" class="mt-10">
                  <div v-if="this.image_listattach.length > 0">
                    <v-row
                      v-for="(item, index) in this.image_listattach"
                      :key="index"
                      style="padding-left: 70px"
                    >
                      <span @click="previewattachfile(index)" class="file-link">
                        {{ item.name }}
                      </span>
                      <v-btn
                        icon
                        color="red"
                        @click="confirmdeleteattachfile(index)"
                        style="margin-top: -7px"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row align="start">
                <v-col cols="4" sm="4" md="4">
                  <h3>Upload Receipt(s)</h3>
                  <input
                    type="file"
                    accept="application/pdf,image/png,image/jpeg"
                    multiple="multiple"
                    @change="previewMultiReceipt"
                    ref="receipt"
                    style="display: none"
                  />
                  <v-btn
                    :style="{
                      backgroundColor: '#254E58',
                      color: 'white',
                    }"
                    @click="$refs.receipt.click()"
                    class="widthbtnnoticefile"
                    elevation="7"
                  >
                    <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                    >Upload</v-btn
                  >
                </v-col>
                <v-col cols="8" sm="8" md="8" class="mt-10">
                  <div v-if="this.image_listrecicpt.length > 0">
                    <v-row
                      v-for="(item, index) in this.image_listrecicpt"
                      :key="index"
                      style="padding-left: 70px"
                    >
                      <span
                        @click="previewreceiptfile(index)"
                        class="file-link"
                      >
                        {{ item.name }}
                      </span>
                      <v-btn
                        icon
                        color="red"
                        @click="confirmdeleteattreceipt(index)"
                        style="margin-top: -7px"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mb-5" align="start">
                <v-col cols="4">
                  <h3>Upload Soft File(s)</h3>
                  <v-btn
                    :style="{ backgroundColor: '#254E58', color: 'white' }"
                    @click="openselectFileWorld()"
                    class="widthbtnnoticefile"
                    elevation="7"
                  >
                    <v-icon left dark color="white">mdi-cloud-upload</v-icon
                    >Upload
                  </v-btn>
                </v-col>

                <v-col cols="8" class="mt-8">
                  <v-row
                    v-for="(label, key) in checkboxFields"
                    :key="key"
                    v-if="checkboxes[key]"
                  >
                    <v-col cols="4" style="padding-left: 70px">
                      <h4>{{ label }}</h4>
                    </v-col>

                    <v-col cols="8">
                      <div style="display: flex; align-items: flex-start">
                        <!-- คอลัมน์ : -->
                        <div style="padding-right: 11px">
                          <h4 style="margin: 0">:</h4>
                        </div>

                        <div>
                          <!-- ไฟล์ใหม่ -->
                          <div
                            v-if="
                              uploadedFiles[key] && uploadedFiles[key].length
                            "
                          >
                            <div
                              v-for="(file, index) in uploadedFiles[key]"
                              :key="'new-' + index"
                              class="d-flex align-center"
                              style="margin-bottom: 5px"
                            >
                              <span style="color: green">{{ file.name }}</span>
                              <v-icon
                                color="red"
                                small
                                class="ml-2"
                                style="cursor: pointer"
                                @click="removeUploadedFile(key, index)"
                              >
                                mdi-close
                              </v-icon>
                            </div>
                          </div>

                          <!-- ไฟล์เก่า -->
                          <div
                            v-if="
                              existingFiles[key] && existingFiles[key].length
                            "
                          >
                            <div
                              v-for="(file, index) in existingFiles[key]"
                              :key="'old-' + index"
                              class="d-flex align-center"
                              style="margin-bottom: 5px"
                            >
                              <a
                                :href="file.previewUrl"
                                download
                                target="_blank"
                                style="color: #1d88ac; text-decoration: underline"
                              >
                                {{ file.name }}
                              </a>
                              <v-icon
                                color="red"
                                small
                                class="ml-2"
                                style="cursor: pointer"
                                @click="removeExistingFile(key, index)"
                              >
                                mdi-close
                              </v-icon>
                            </div>
                          </div>
                        </div>

                        <!-- คอลัมน์ ปุ่ม + -->
                        <div style="margin-left: 20px">
                          <input
                            :ref="`fileInput_${key}`"
                            type="file"
                            multiple
                            accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            style="display: none"
                            @change="handleFileUpload($event, key)"
                          />
                          <v-icon
                            width="15px"
                            class="bt-add"
                            style="cursor: pointer"
                            @click="triggerFileInput(key)"
                          >
                            mdi-plus
                          </v-icon>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <div v-if="showChage">
                <v-checkbox
                  v-model="changeMasterRecord.type"
                  label="Type"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.title"
                  label="Title"
                  style="margin-top: -20px"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.titleInThai"
                  label="Title In Thai"
                  style="margin-top: -20px"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.clientName"
                  label="Client Name"
                  style="margin-top: -20px"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.agentReference"
                  label="Agent Reference"
                  style="margin-top: -20px"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.agentName"
                  label="Agent Name"
                  style="margin-top: -20px"
                ></v-checkbox>
                <v-checkbox
                  v-model="changeMasterRecord.associateName"
                  label="Associate Name"
                  style="margin-top: -20px"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row
            justify="space-around"
            class="heightsize90formadvance"
            v-if="showNewFilingExact"
          >
            <v-col cols="12" sm="3" md="3">
              <h3>Application Date</h3>
              <v-menu
                v-model="menuaddAppD"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.date_of_application"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      date_of_application = parseDate(
                        itemdata.date_of_application,
                      )
                    "
                    @blur="
                      date_of_application = parseDate(
                        itemdata.date_of_application,
                      )
                    "
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="
                      $nextTick(() => {
                        itemdata.date_of_application = null;
                      })
                    "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_of_application"
                  @input="menuaddAppD = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Application Number</h3>
              <v-text-field
                v-model="itemdata.app_no"
                outlined
                dense
                @blur="onAppNoBlur"
              ></v-text-field>
            </v-col>
            <v-col cols="0" sm="6" md="6" />
          </v-row>

          <v-row
            justify="space-around"
            class="heightsize90formadvance"
            v-if="showNew"
          >
            <v-col cols="12" sm="3" md="3" v-if="!showNewFilingSubdoc">
              <h3>Priority Deadline</h3>
              <v-menu
                v-model="menuaddnewfilling"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.new_filling"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      new_filling = parseDate(itemdata.new_filling)
                    "
                    @blur="new_filling = parseDate(itemdata.new_filling)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="new_filling"
                  @input="menuaddnewfilling = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-if="showNewFilingExact">
              <h3>Internal Deadline</h3>
              <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.enddate"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="enddate = parseDate(itemdata.enddate)"
                    @blur="enddate = parseDate(itemdata.enddate)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="enddate"
                  @input="menuStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-else />
            <v-col cols="12" sm="6" md="6" />
          </v-row>
          <v-row
            justify="space-around"
            class="heightsize90formadvance"
            v-if="showChage"
          >
            <v-col cols="12" sm="3" md="3">
              <h3>Submit Date</h3>
              <v-menu
                v-model="menuFilling"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.filling_date"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      filling_date = parseDate(itemdata.filling_date)
                    "
                    @blur="filling_date = parseDate(itemdata.filling_date)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="filling_date"
                  @input="menuFilling = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="9" md="9" />
          </v-row>
          <v-row
            justify="space-around"
            class="heightsize90formadvance"
            v-if="default_col"
          >
            <v-col cols="12" sm="3" md="3">
              <h3 v-if="showSub">
                <span class="red--text">* </span>Publication Date
              </h3>
              <h3 v-else-if="showNewFilingSubdoc">
                <span class="red--text">* </span>Application Date
              </h3>
              <h3 v-else><span class="red--text">* </span>Receive Date</h3>
              <v-menu
                v-model="menuReceive"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.receive_date"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      receive_date = parseDate(itemdata.receive_date)
                    "
                    @blur="receive_date = parseDate(itemdata.receive_date)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="receive_date"
                  @input="
                    () => {
                      menuReceive = false;
                      calDateFinalDeadline();
                    }
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Submit Date</h3>
              <v-menu
                v-model="menuFilling"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.filling_date"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      filling_date = parseDate(itemdata.filling_date)
                    "
                    @blur="filling_date = parseDate(itemdata.filling_date)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="filling_date"
                  @input="menuFilling = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <h3 v-if="showSub">
                <span class="red--text">* </span>Sub Exam Request Deadline Date
              </h3>
              <h3 v-else><span class="red--text">* </span>Final Deadline</h3>
              <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.enddate"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="enddate = parseDate(itemdata.enddate)"
                    @blur="enddate = parseDate(itemdata.enddate)"
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="enddate"
                  @input="menuStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3><span class="red--text">* </span>Fixed Internal Date</h3>
              <v-menu
                v-model="menuDeadline"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.internaldate"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      internaldate = parseDate(itemdata.internaldate)
                    "
                    @blur="internaldate = parseDate(itemdata.internaldate)"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    disabled
                    background-color="#F5F5F5"
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="internaldate"
                  @input="menuDeadline = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3"></v-col>
          </v-row>
          <v-row
            justify="space-around"
            class="heightsize90formadvance"
            v-if="showAnn"
          >
            <v-col cols="12" sm="3" md="3">
              <h3>Last Annuity Payment</h3>
              <v-autocomplete
                v-model="itemdata.dead_last_annuity_paid"
                :items="latest_list"
                outlined
                dense
                @input="calDateAnn()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Date Of The Last Annuity Payment</h3>
              <v-menu
                v-model="menuaddlapd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.last_annuity_paid"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                    "
                    @blur="
                      last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                    "
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="last_annuity_paid"
                  @input="menuaddlapd = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" md="3">
              <h3>Next Payment Due Date</h3>
              <v-menu
                v-model="menuaddnad"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.next_annuity_date"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      next_annuity_date = parseDate(itemdata.next_annuity_date)
                    "
                    @blur="
                      next_annuity_date = parseDate(itemdata.next_annuity_date)
                    "
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="next_annuity_date"
                  @input="
                    () => {
                      menuaddnad = false;
                      updateFinalDueDateFromNextAnnuity();
                    }
                  "
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Final Due Date For Next Payment</h3>
              <v-menu
                v-model="menuaddnadfinalDatePayment"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="itemdata.final_due_date_for_next_payment"
                    persistent-hint
                    hint="Format DD/MM/YYYY"
                    @keydown.enter="
                      final_due_date_for_next_payment = parseDate(
                        itemdata.final_due_date_for_next_payment,
                      )
                    "
                    @blur="
                      final_due_date_for_next_payment = parseDate(
                        itemdata.final_due_date_for_next_payment,
                      )
                    "
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                  ></v-text-field>
                </template>

                <v-date-picker
                  v-model="final_due_date_for_next_payment"
                  @input="menuaddnadfinalDatePayment = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row justify="space-around" v-if="default_type">
            <v-col cols="12" sm="3" md="3">
              <h3>Source Type</h3>
              <v-select
                v-model="itemdata.sourcetype"
                clearable
                :items="sourcetypelist"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Type</h3>
              <v-select
                v-model="typeshow"
                clearable
                :items="typelist"
                item-text="type_name"
                item-value="type_number"
                outlined
                dense
                disabled
                background-color="#F5F5F5"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h3>Title</h3>
              <v-text-field
                v-model="titleshow"
                outlined
                dense
                disabled
                background-color="#F5F5F5"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="12" sm="6" md="6">
              <h3>Description</h3>
              <v-textarea v-model="itemdata.description" outlined dense>
              </v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h3>Remark</h3>
              <v-textarea v-model="itemdata.remark" outlined dense>
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" md="2">
              <h3>Status</h3>
              <v-select
                v-model="itemdata.closed"
                :items="statuslist"
                item-text="descriptions"
                item-value="module_id"
                outlined
                dense
                @change="sendToStatus"
              ></v-select>
            </v-col>
            <v-col cols="4" md="3">
              <h3>Reported / Invoiced</h3>
              <v-select
                v-model="itemdata.report"
                clearable
                :items="reportlist"
                item-text="report_name"
                item-value="report_value"
                outlined
                dense
              ></v-select>
            </v-col>
            <!-- <v-col cols="4" md="2" >
                <v-checkbox
                  v-model="itemdata.cert"
                  :label="`Pending`"
                  color="success"
                  hide-details
                ></v-checkbox>
                &nbsp;
              </v-col>
              <v-col cols="4"  md="2">
                <v-checkbox
                  v-model="itemdata.report"
                  :label="`Report`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="4" md="2">
                <v-checkbox
                  v-model="itemdata.done"
                  :label="`Complete`"
                  color="success"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="4" md="2">

              </v-col> -->
          </v-row>
          <!-- ============ SECTION E: การเงิน / INVOICE ============ -->
          <div class="sec mt-6">
            <InvoiceSectionPanel
              class="mt-6"
              :sales-order-id.sync="formQutations.salesOrderId"
              :customer-name="formQutations.customerName"
              :price="formQutations.price"
              :currency="formQutations.currency"
              :sales-order-list="salesOrderList"
              :invoice-list="invoiceList"
              :invoice-status-list="invoiceStatusList"
              section-label="E · การเงิน & สถานะ Invoice"
              @select-so="onSelectSO"
              @preview="previewInvoice"
            />
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-card-text v-if="tabselect == 1">
      <TimeLineOperations
        :showaddItem="itemdata"
        :statuslist="statuslist"
        :reportlist="reportlist"
        :modeOperations="modeOperations"
        :timelineStatus="timelineStatus"
        :status_note="status_note"
        :visible_check="visible_check"
        :showReportInv="true"
        :timeline_case_id="timeline_case_id"
        :module_name="module_name"
        @timelineStatus="timelineStatus = $event"
        @requestStatus="handleRequestStatus"
        @update:status_note="status_note = $event"
        @update:visible_check="visible_check = $event"
      />
    </v-card-text>
    <v-card-actions v-if="this.check_closed">
      <v-spacer></v-spacer>
      <!-- <v-btn
          @click="$router.back()"
          depressed
          outlined
          width="100"
          color="red"
        >
          Delete
        </v-btn> -->
      <v-btn
        depressed
        :class="['mr-3 buttongold', { 'is-locked': requestPaymentDisabled }]"
        title="เปิดใช้เมื่อมี Price + Quotation ID + File No. แล้วเท่านั้น"
        @click="requestPaymentDisabled ? null : saveItem('paymentrequest')"
      >
        Payment Request
      </v-btn>
      <v-btn
        @click="saveItem('save')"
        width="100"
        class="mr-3 ml-3 buttonblue"
        color="#112D32"
      >
        Save
      </v-btn>
      <v-btn
        @click="$router.push(`/appointment-patent-list`)"
        depressed
        outlined
        width="100"
      >
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <br />
    </v-card-actions>

    <v-dialog v-model="dialogpreviewfilenotice" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkfileapreview"
          v-for="(item, index) in previewpopupfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreview"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkattachfileapreview"
          v-for="(item, index) in previewpopupattachfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreviewattach"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewattachimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title
        >

        <v-img
          disabled
          :src="previewattachimage"
          class="grey lighten-2 mt-3 mb-5"
          aspect-ratio="1"
          contain
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewattachimage"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeletenoticefile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeletenoticefile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closedialogconfirmdeleteattachfile"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeleteattachfile"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogconfirmdeleteattrecipt" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewreceipt"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="deletedialogconfirmdeletereceipt"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCheckbox" max-width="250px" persistent>
      <v-card class="pr-6 pl-6">
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="checkboxes.Form001"
            label="Form 001ก"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Descriptions"
            label="Descriptions"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Claims"
            label="Claims"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Drawings"
            label="Drawings"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Abstract"
            label="Abstract"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="cancelCheckbox">Cancel</v-btn>
          <v-btn color="primary" text @click="saveSelection">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCheckbox" max-width="250px" persistent>
      <v-card class="pr-6 pl-6">
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="checkboxes.Form001"
            label="Form 001ก"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Descriptions"
            label="Descriptions"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Claims"
            label="Claims"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Drawings"
            label="Drawings"
          ></v-checkbox>
          <v-checkbox
            style="margin-top: -10px"
            v-model="checkboxes.Abstract"
            label="Abstract"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="cancelCheckbox">Cancel</v-btn>
          <v-btn color="primary" text @click="saveSelection">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="600px">
      <v-card class="pa-10" style="border: 5px solid #e5e7eb;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="text-h4 font-weight-bold"
              >Timeline Update Required</span
            >
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center" class="text-center">
            <span class="black--text text-body-1">
              Before saving this case, please update the internal timeline so
              the team can see the latest work status.
            </span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            width="170"
            class="mr-3 "
            color="#0A7EA5"
            @click="deleteItemConfirm"
            style="border-radius: 20px; color: white; text-transform: none;"
          >
            Update Timeline
          </v-btn>
          <v-btn
            depressed
            width="170"
            @click="closeDelete"
            color="red"
            style="border-radius: 20px; color: white; text-transform: none;"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <!-- <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card> -->
    </v-dialog>
    <v-dialog v-model="dialogOutstanding" max-width="560px" persistent>
      <v-card class="outstanding-card">
        <div class="outstanding-header">
          <div class="outstanding-icon">
            <v-icon color="#B7791F" size="34">mdi-alert-outline</v-icon>
          </div>
          <div class="outstanding-title">Outstanding invoice found</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="continueAnyway">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="outstanding-body">
          <p class="outstanding-text">
            This customer has an unpaid invoice.
          </p>

          <div class="outstanding-list">
            <div
              v-for="inv in outstandingInvoices"
              :key="inv.inv_h_id"
              class="outstanding-box"
            >
              <div class="outstanding-col">
                <div class="outstanding-label">Customer</div>
                <div class="outstanding-value">{{ inv.cus_name || "-" }}</div>
              </div>
              <div class="outstanding-divider"></div>
              <div class="outstanding-col">
                <div class="outstanding-label">Invoice number</div>
                <div class="outstanding-value">{{ inv.inv_no }}</div>
              </div>
              <v-spacer></v-spacer>
              <span class="outstanding-chip">{{ inv.status_name }}</span>
            </div>
          </div>

          <p class="outstanding-hint">
            Please review the outstanding invoice before continuing.
          </p>
        </div>

        <div class="outstanding-separator"></div>

        <div class="outstanding-actions">
          <v-spacer></v-spacer>
          <v-btn outlined large class="btn-back" @click="backToList">
            Back to list
          </v-btn>
          <v-btn
            large
            depressed
            dark
            color="#1D2B4F"
            class="btn-continue"
            @click="continueAnyway"
          >
            Continue anyway
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
    <SuccessDialogPushpaymentIM
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
      :querydata="querydata"
    />
  </v-container>
</template>

<script>
import SuccessDialogPushpaymentIM from "@/components/cards/SuccessDialogPushpaymentIM";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import {
  server,
  imageappointmentTMUrl,
  fileappointmentTMUrl,
} from "@/services/constants";
import pdfvuer from "pdfvuer";
import TimeLineOperations from "../../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../../payment-invoice/InvoiceSectionPanel.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");

export default {
  name: "AppoinmrntPatentOperation",

  components: {
    SuccessDialog,
    SuccessDialogPush,
    SuccessDialogPushpaymentIM,
    pdf: pdfvuer,
    TimeLineOperations,
    InvoiceSectionPanel,
  },
  data() {
    return {
      uploadedFiles: {},
      existingFiles: {},
      oldFiles: {},
      oldFilesCheck: {},
      uploadedFilesDoctype: {},
      menuaddAppD: false,
      check_closed: true,
      dialogCheckbox: false,
      checkboxes: {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      },
      checkboxFields: {
        Form001: "Form 001ก",
        Descriptions: "Descriptions",
        Claims: "Claims",
        Drawings: "Drawings",
        Abstract: "Abstract",
      },
      querydata: {},
      dataappiontment: {},
      isShowPassword: false,
      fullPage: true,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      objecttype_list: [],
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuaddlapd: false,
      menuDeadline: false,
      sourcetypelist: ["Electronic Notice", "Physical Paper Notice", "EMail"],
      category_ptlist: [
        "New Application",
        "Office Action",
        "Publication Fee",
        "Publication",
        "Substantive Examination",
        "Publication Fee & Registration Fee",
        "Publication Fee & Registration Fee & Annuity Fee",
        "Registration Fee",
        "Registration Fee & Annuity Fee",
        "Certificate",
        "Annuity Fee",
      ],
      doctype_actions_select: [],
      doctype_actions_select_old: [],
      doctype_actions_tlist: [],
      typelist: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention/PCT", type_number: "4" },
      ],
      documenttype_ptlist: [],
      documenttype_ptlist_search: [],
      app_noshow: "",
      typeshow: 0,
      titleshow: "",
      receive_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10),
      filling_date: null,
      startdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      enddate: null,
      date_of_application: null,
      internaldate: null,
      itemdata: {
        date_of_application: null,
        last_annuity_paid: null,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        dead_last_annuity_paid: "",
        app_no: "",
        objecttype: 0,
        doctype: 0,
        trademark_name: "",
        refno: "",
        categories: "",
        filling_date: null,
        receive_date: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        ),
        startdate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        ),
        enddate: null,
        internaldate: this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
        ),
        sourcetype: "",
        description: "",
        remark: "",
        report: 0,
        paymentrequest: false,
        cert: false,
        nextdeadlineninety: false,
        nextdeadlinesixty: false,
        done: false,
        closed: 1,
      },
      getpreview_listnotice: [],
      preview_listnotice: [],
      image_listnotice: [],
      filenamenotice: [],
      preview_listnotice2: [],
      preview_listattach: [],
      preview_listrecicpt: [],
      image_listattach: [],
      image_listrecicpt: [],
      image_listrecicpt_old: [],
      filenameattach: [],
      filenamerecive: [],
      getpreview_listattach: [],
      getpreview_listreceipt: [],
      preview_listattach2: [],
      preview_listrecipt2: [],
      previewpopupfile: [],
      previewpopupfile2: [],
      checkfileapreview: false,
      dialogpreviewfilenotice: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      numPagespreviewattach: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      previewattachimage: "",
      dialogpreviewattachimage: false,
      dialogconfirmdeletenoticefile: false,
      dialogconfirmdeleteattachfile: false,
      dialogconfirmdeleteattrecipt: false,
      indexdeleteattachfile: -1,
      indexdeleteattreciept: -1,
      indexdeleteattachfilelist: -1,
      customer_id_forpatmentrequest: 0,
      showAnn: false,
      showAnnReg: false,
      showAnnfirst: false,
      showChage: false,
      showNew: false,
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      menuaddnewfilling: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      new_filling: false,
      data_maserter_pt: [],
      data_maserter_pt_priority: [],
      default_col: true,
      default_type: true,
      last_annuity_paid: null,
      next_annuity_date: null,
      final_due_date_for_next_payment: null,
      associate_contact_name: "",
      agent_contact_name: "",
      contact_agent_list: [],
      contact_associate_list: [],
      contact_owner_list: [],
      changeMasterRecord: {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      },
      showSub: false,
      showNewFilingExact: false,
      showNewFilingSubdoc: false,
      statuslist: [
        // { status_name: "Pending", status_value: 1 },
        // { status_name: "Completed", status_value: 2 },
        // { status_name: "Close", status_value: 3 },
        // { status_name: "Payment Request", status_value: 4 },
      ],
      reportlist: [
        { report_name: "Not Reported", report_value: 0 },
        { report_name: "Reported", report_value: 4 },
        { report_name: "Reported – Pending Invoice", report_value: 1 },
        { report_name: "Invoiced", report_value: 2 },
        { report_name: "Reported & Invoiced", report_value: 3 },
      ],
      //timeline
      modeOperations: "Edit",
      tabselect: 0,
      timelineStatus: 0,
      status_note: "",
      visible_check: false,
      dialogDelete: false,
      timeline_case_id: Number(this.$route.params.appointment_id),
      module_name: "Patent Docket",
      //quotations
      formQutations: {
        salesOrderId: 0,
        price: 0,
        customerName: "",
        currency: "",
      },
      salesOrderList: [],
      invoiceList: [],
      // invoiceMenu: false,
      // invoiceMenuPay: false,
      invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
      quotationscheckstatus: "",
      querydata: "",
      // outstanding invoice dialog
      dialogOutstanding: false,
      outstandingInvoices: [],
    };
  },
  async mounted() {
    await api.checkVersion();
    await this.loaddataSalesOrder();
    await this.loadDataInvoice(this.$route.params.appointment_id);
    await this.loadStatusList();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatadocumentPTtype();

    await this.loaddatafile_no();

    if (this.app_noshow !== "" && this.itemdata.refno !== "") {
      // --------------- check data in ocr table ----------------
      let ocr_data = await api.checkAppointmentOCR(
        this.app_noshow,
        this.itemdata.refno,
      );

      if (ocr_data.data !== null) {
        let map_data = await api.mapKeyWordPT(
          this.app_noshow,
          this.itemdata.refno,
        );
        this.itemdata.doctype = map_data.data.doctype_id;
      }

      // --------------- check data in map table ----------------
    }
    await this.loadDataDotypeAction();
    this.prev_doctype_actions_select = [...this.doctype_actions_select];

    await this.loaddataApp();
    await this.loadreceiptfile();
    await this.loadSoftfile();
    await this.loadChageRC();

    this.$hideLoader();
    // เช็คว่า Billing Customer ของแฟ้มนี้มี invoice ค้าง
    // [NEW] ใช้ checkOutstandingInvoiceOnEdit (ไม่ await) -> ถ้า API error จะไม่เด้งไป dashboard
    if (this.itemdata.refno) {
      this.checkOutstandingInvoiceOnEdit(this.itemdata.refno);
    }
  },
  computed: {
    requestPaymentDisabled() {
      const price = Number(this.formQutations.price);
      const salesOrderId = Number(this.formQutations.salesOrderId);

      const isPriceValid = !isNaN(price) && price > 0;
      const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
      const isFileNoValid = !!(this.itemdata.refno || "").toString().trim();

      return !(isPriceValid && isSalesOrderIdValid && isFileNoValid);
    },
  },
  methods: {
    // [NEW] เช็ค outstanding invoice สำหรับหน้า Edit เท่านั้น
    // เรียกผ่าน httpClientSilent: ถ้า API ตอบ 404/500 จะไม่ redirect ออกจากหน้า
    async checkOutstandingInvoiceOnEdit(fileNo) {
      try {
        const res = await api.getOutstandingInvoiceByBillingCustomerPTSilent(
          fileNo,
        );
        const rows = res && Array.isArray(res.data) ? res.data : [];
        if (rows.length > 0) {
          this.outstandingInvoices = rows;
          this.dialogOutstanding = true;
        } else {
          this.outstandingInvoices = [];
        }
      } catch (error) {
        this.outstandingInvoices = [];
        console.warn(
          "checkOutstandingInvoiceOnEdit skipped:",
          error && error.message ? error.message : error,
        );
      }
    },
    async checkOutstandingInvoice(fileNo) {
      try {
        const res = await api.getOutstandingInvoiceByBillingCustomerPT(fileNo);
        const rows = res.data || [];
        if (rows.length > 0) {
          this.outstandingInvoices = rows;
          this.dialogOutstanding = true;
        } else {
          this.outstandingInvoices = [];
        }
      } catch (error) {
        console.error("checkOutstandingInvoice error:", error);
      }
    },
    backToList() {
      this.dialogOutstanding = false;
      this.$router.push("/appointment-patent-list");
    },
    continueAnyway() {
      this.dialogOutstanding = false;
    },
    //quotations
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(
          Number(localStorage.getItem(server.COMPANYID)),
        );
        this.salesOrderList = res.data || [];
      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(so) {
      // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
      if (!so) {
        this.formQutations.price = "";
        this.formQutations.customerName = "";
        this.formQutations.currency = "";
        this.quotationscheckstatus = "";
        return;
      }
      this.quotationscheckstatus = so.status;
      this.formQutations.price = Number(so.subtotal);
      this.formQutations.customerName = so.customer_name || "";
      this.formQutations.currency = so.currency || "";
    },
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`,
      );
      window.open(routeData.href, "_blank");
    },
    async loadDataInvoice(id) {
      try {
        var dataserach = {
          module_name: "Docket",
          module_id: id,
          company_id: Number(localStorage.getItem(server.COMPANYID)),
        };
        const res = await api.getQuotatinsinvoiceListCore({
          params: dataserach,
        });
        this.invoiceList = res.data.data || [];
      } catch (error) {
        console.error("loadDataInvoice error:", error);
      }
    },
    //end quotattions
    //timeline functions
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },

    handleRequestStatus(value) {
      this.itemdata.closed = Number(value);
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        (item) => item.module_id === value,
      );
      this.timelineStatus = Number(selectedItem.timeline_status_id);
    },
    async loadStatusList() {
      const result = await api.getClientTimelineStatusCongFigByModule(
        "Patent Docket",
      );

      this.statuslist = (result.data || []).map((item) => ({
        ...item,
        module_id: Number(item.module_id),
      }));
    },
    //end time line functions

    async onAppNoBlur() {
      var check_appno = await api.getAppNpCheck({
        params: {
          id: this.data_maserter_pt.masterpt_id,
          app_no: this.itemdata.app_no,
        },
      });
      if (check_appno.status == 203) {
        this.itemdata.app_no = this.data_maserter_pt.app_no;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check Application No.",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    handleFileUpload(event, key) {
      const files = Array.from(event.target.files);

      // เก็บชื่อไฟล์ทั้งหมดที่มีอยู่ใน uploadedFiles ทุก key
      const allUploadedNames = Object.values(this.uploadedFiles)
        .flat()
        .map((f) => f.name);

      // รวมชื่อไฟล์เก่าจาก oldFiles ทุก key
      const oldFileNames = Object.values(this.oldFiles || {}).flat();

      if (!this.uploadedFiles[key]) {
        this.$set(this.uploadedFiles, key, []);
      }

      files.forEach((file) => {
        let newName = file.name;
        let baseName = newName;
        let ext = "";

        // แยกนามสกุลไฟล์ (.docx, .doc ฯลฯ)
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          baseName = newName.substring(0, dotIndex);
          ext = newName.substring(dotIndex);
        }

        let counter = 1;
        // ตรวจสอบชื่อไฟล์ซ้ำทั้งใน uploadedFiles และ oldFiles
        while (
          allUploadedNames.includes(newName) ||
          oldFileNames.includes(newName)
        ) {
          newName = `${baseName}-${counter}${ext}`;
          counter++;
        }

        // สร้างไฟล์ใหม่ clone พร้อมชื่อใหม่
        const renamedFile = new File([file], newName, { type: file.type });

        // เพิ่มชื่อใหม่เข้า allUploadedNames เพื่อกันชื่อซ้ำกับไฟล์ถัดไป
        allUploadedNames.push(newName);

        // เพิ่มไฟล์ลงใน uploadedFiles
        this.uploadedFiles[key].push(renamedFile);
      });
    },

    removeUploadedFile(key, index) {
      this.uploadedFiles[key].splice(index, 1);
    },
    removeExistingFile(key, index) {
      if (!this.existingFiles[key]) return;

      // clone existingFiles object ทั้งหมด
      const newExistingFiles = { ...this.existingFiles };

      // clone array ของ key นั้น แล้วลบ element index ออก
      newExistingFiles[key] = [...newExistingFiles[key]];
      newExistingFiles[key].splice(index, 1);

      // อัพเดต reactive ด้วยการแทนที่ตัวใหม่ทั้ง object
      this.existingFiles = newExistingFiles;

      // ถ้ามี oldFiles ที่เก็บชื่อไฟล์ก็ทำแบบเดียวกัน
      if (this.oldFiles && this.oldFiles[key]) {
        const newOldFiles = { ...this.oldFiles };
        newOldFiles[key] = [...newOldFiles[key]];
        newOldFiles[key].splice(index, 1);
        this.oldFiles = newOldFiles;
      }

      // ปิด checkbox ถ้าไฟล์หมด
      if (newExistingFiles[key].length === 0) {
        this.checkboxes = { ...this.checkboxes, [key]: false };
      }
    },

    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      if (this.showAnnfirst) {
        date.setDate(date.getDate() + 59); // บวก 60 วัน
      } else {
        date.setDate(date.getDate() + 60);
      }

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    chageobjecttype() {
      if (this.itemdata.objecttype != 0) {
        const matchedDoc = this.documenttype_ptlist.filter(
          (item) => item.objecttype_id == this.itemdata.objecttype,
        );

        this.documenttype_ptlist_search = matchedDoc;
        const exists = this.documenttype_ptlist_search.some(
          (item) => item.documenttype_id === this.itemdata.doctype,
        );
        if (!exists) {
          this.itemdata.doctype = 0;
        }
      }
    },
    async loadChageRC() {
      const res_crc = await api.getCHAGE_MASTER_RECORD_BYID(
        this.$route.params.appointment_id,
      );

      if (
        this.showChage &&
        Array.isArray(res_crc.data) &&
        res_crc.data.length > 0
      ) {
        // สร้าง object ที่แมทกับ changeMasterRecord
        const mappedData = res_crc.data.reduce((acc, item) => {
          acc[item.field_name] = item.status === true;
          return acc;
        }, {});

        // อัปเดตค่าใน changeMasterRecord ทีละ field ถ้ามี key ตรงกัน
        for (const key in this.changeMasterRecord) {
          if (mappedData.hasOwnProperty(key)) {
            this.changeMasterRecord[key] = mappedData[key];
          }
        }
      }
    },

    async loaddataApp() {
      if (this.$route.params.appointment_id) {
        this.appointment_id = this.$route.params.appointment_id;
        this.FlieArray = [];
        this.image_listnotice = [];
        this.image_listattach = [];
        this.filenamenotice = [];

        var data_search = {
          tbl_name1: "appointment_attachment_files",
          tbl_name2: "appointment_notice_file",
          tbl_id: Number(this.appointment_id),
        };

        const result_file = await api.getAllFileAtLawFileAp({
          params: data_search,
        });

        if (result_file.data.length > 0) {
          this.oldnotifile = [];
          this.oldnotiimage = [];
          this.oldattfile = [];
          this.oldattimage = [];

          this.FlieArray = result_file.data;

          for (const [index, item] of result_file.data.entries()) {
            if (item.tbl_name == "appointment_notice_file") {
              if (item.file_type == "file") {
                this.image_listnotice.push(`${item.file_name}`);
                this.filenamenotice.push(item.file_name);
                this.oldnotifile.push(item.file_name);
              } else {
                this.image_listnotice.push(`${item.file_name}`);
                this.filenamenotice.push(item.file_name);
                this.oldnotiimage.push(item.file_name);
              }
            } else {
              var data = {
                name: item.file_name,
              };

              if (item.file_type == "file") {
                this.oldattfile.push(data);
              } else {
                this.oldattimage.push(data);
              }

              this.image_listattach.push(data);
            }
          }
        }

        const resultappointment = await api.AppointmentgetById(
          this.appointment_id,
        );

        this.formQutations.salesOrderId =
          resultappointment.data[0].quotation_id || 0;
        // ค้น object เองตอนโหลดข้อมูลเดิม เพราะไม่ได้ผ่าน event จาก component
        const so = this.salesOrderList.find(
          (item) =>
            Number(item.quotation_id) ===
            Number(this.formQutations.salesOrderId),
        );
        this.onSelectSO(so || null);

        const res_doc = this.documenttype_ptlist.find(
          (item) => item.documenttype_id === resultappointment.data[0].doctype,
        );

        const result = await api.getfile_noPT(resultappointment.data[0].refno);
        //set ann env
        // this.data_maserter_pt = result.data[0];
        this.data_maserter_pt.dead_last_annuity_paid_pt =
          resultappointment.data[0].dead_last_annuity_paid;
        this.data_maserter_pt.last_annuity_paid_pt =
          resultappointment.data[0].last_annuity_paid;
        this.data_maserter_pt.next_annuity_date_pt =
          resultappointment.data[0].next_annuity_date;
        this.data_maserter_pt.final_due_date_for_next_payment_pt =
          resultappointment.data[0].final_due_date_for_next_payment;

        //set New Filing env

        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id),
        );
        this.data_maserter_pt_priority = res_priority.data;

        if (res_doc && res_doc.documenttype_code) {
          const type_check_an = res_doc.documenttype_code.includes(
            "Annuity Fees",
          );
          if (type_check_an) {
            this.default_col = false;
            this.showAnn = true;
            this.itemdata.dead_last_annuity_paid =
              resultappointment.data[0].dead_last_annuity_paid;
            this.itemdata.last_annuity_paid = this.formatDate(
              resultappointment.data[0].last_annuity_paid,
            );
            this.itemdata.next_annuity_date = this.formatDate(
              resultappointment.data[0].next_annuity_date,
            );
            this.itemdata.final_due_date_for_next_payment = this.formatDate(
              resultappointment.data[0].final_due_date_for_next_payment,
            );
            if (res_doc.documenttype_code === "Registration & Annuity Fees") {
              this.showAnnReg = true;
              this.default_col = true;
              this.itemdata.receive_date =
                resultappointment.data[0].receive_date == "0000-00-00"
                  ? null
                  : resultappointment.data[0].receive_date;
              this.itemdata.startdate = resultappointment.data[0].startdate;
              this.itemdata.enddate = resultappointment.data[0].enddate;
              this.itemdata.filling_date =
                resultappointment.data[0].filling_date;
              this.itemdata.internaldate =
                resultappointment.data[0].internaldate == "0000-00-00"
                  ? null
                  : resultappointment.data[0].internaldate;
            } else {
              this.showAnnfirst = true;
            }
          } else {
            this.data_maserter_pt = result.data[0];
          }

          const type_check_new = res_doc.documenttype_code.includes(
            "New Filing",
          );
          if (type_check_new) {
            this.showNew = true;
            this.itemdata.new_filling = this.formatDate(
              resultappointment.data[0].new_filling,
            );
            if (res_doc.documenttype_code === "New Filing") {
              this.default_col = false;
              this.showNewFilingExact = true;
              this.showNewFilingSubdoc = false;
              this.itemdata.app_no = this.data_maserter_pt.app_no;
              this.itemdata.date_of_application = this.formatDate(
                this.data_maserter_pt.date_of_application,
              );
              this.date_of_application = this.data_maserter_pt.date_of_application;
            } else if (res_doc.documenttype_code === "New Filing Sub Doc") {
              this.default_col = true;
              this.showNewFilingSubdoc = true;
              this.showNewFilingExact = false;
            } else {
              this.showNewFilingExact = false;
              return;
            }
          }

          const type_check_changeMasterRecord = res_doc.documenttype_code.includes(
            "Change Master of Record",
          );
          if (type_check_changeMasterRecord) {
            this.showAnn = false;
            this.showNew = false;
            this.default_col = false;
            this.default_type = false;
            this.showChage = true;
          }

          const type_check_sub = res_doc.documenttype_code.includes(
            "Substantive Examination",
          );
          if (type_check_sub) {
            this.showSub = true;
          }
        }

        if (!resultappointment.data[0].documenttype_action_id) {
          var dataSearch = {
            appointment_type: "Patent",
            appointment_id: this.$route.params.appointment_id,
          };

          var res_doctype_action = await api.getAllAppointmentDoctypeActionsBYID(
            {
              params: dataSearch,
            },
          );

          if (res_doctype_action.data.length > 0) {
            this.doctype_actions_select = res_doctype_action.data.map(
              (item) => item.documenttype_action_id,
            );
            this.doctype_actions_select_old = this.doctype_actions_select;
          } else {
            this.doctype_actions_select = []; // กำหนดค่า default ว่าง ๆ
            this.doctype_actions_select_old = [];
          }
        }

        this.itemdata.refno = resultappointment.data[0].refno.toUpperCase();
        this.itemdata.objecttype = resultappointment.data[0].objecttype;
        this.itemdata.receive_date =
          resultappointment.data[0].receive_date == "0000-00-00"
            ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            : resultappointment.data[0].receive_date;
        this.itemdata.startdate = resultappointment.data[0].startdate;
        this.itemdata.enddate = resultappointment.data[0].enddate;
        this.itemdata.filling_date = resultappointment.data[0].filling_date;
        this.itemdata.internaldate =
          resultappointment.data[0].internaldate == "0000-00-00"
            ? new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10)
            : resultappointment.data[0].internaldate;
        this.itemdata.doctype = resultappointment.data[0].doctype;
        this.itemdata.categories = resultappointment.data[0].categories;
        this.itemdata.description = resultappointment.data[0].description;
        this.itemdata.remark = resultappointment.data[0].remark;
        this.itemdata.nextdeadlineninety =
          resultappointment.data[0].nextdeadlineninety;
        this.itemdata.nextdeadlinesixty =
          resultappointment.data[0].nextdeadlinesixty;
        this.itemdata.report = resultappointment.data[0].report;
        this.itemdata.paymentrequest = resultappointment.data[0].paymentrequest;
        this.itemdata.cert = resultappointment.data[0].cert;
        this.itemdata.done = resultappointment.data[0].done;
        this.itemdata.closed = resultappointment.data[0].closed;

        if (Number(this.itemdata.closed) == 0) {
          this.itemdata.closed = 1;
          this.timelineStatus = 1;
        } else {
          const selectedItem = this.statuslist.find(
            (item) => Number(item.module_id) === Number(this.itemdata.closed),
          );
          this.timelineStatus = Number(selectedItem.timeline_status_id);
        }

        this.itemdata.sourcetype = resultappointment.data[0].sourcetype;
        if (
          this.itemdata.refno != "" &&
          this.itemdata.refno != " " &&
          this.itemdata.refno != ""
        ) {
          // this.onSearchfile_nosave(this.itemdata.refno);
          const resultf = await api.getfile_noPT(this.itemdata.refno);
          this.titleshow = resultf.data[0].title;
          this.app_noshow = resultf.data[0].app_no;
          this.typeshow = resultf.data[0].type;
          this.customer_id_forpatmentrequest =
            resultf.data[0].agent_contact_custid != 0
              ? resultf.data[0].agent_contact_custid
              : resultf.data[0].owner_contact_custid != 0
              ? resultf.data[0].owner_contact_custid
              : 0;
        }
        this.itemdata.receive_date = this.formatDate(
          this.itemdata.receive_date,
        );
        this.itemdata.startdate = this.formatDate(this.itemdata.startdate);
        this.itemdata.enddate = this.formatDate(this.itemdata.enddate);
        this.itemdata.filling_date = this.formatDate(
          this.itemdata.filling_date,
        );
        this.itemdata.internaldate = this.formatDate(
          this.itemdata.internaldate,
        );

        if (
          resultappointment.data[0].notice_file &&
          resultappointment.data[0].notice_file != ""
        ) {
          this.oldnotifile = [];
          this.oldnotiimage = [];

          //เซต table file
          let masterFile = resultappointment.data[0].notice_file;

          // แยกค่าด้วยเครื่องหมายคอมม่า
          let fileArray = masterFile.split(",");

          // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
          fileArray = fileArray.map((image) => image.trim());

          // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
          if (fileArray[fileArray.length - 1] === "") {
            fileArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
          }
          if (fileArray.length > 0) {
            for (const [index, item] of fileArray.entries()) {
              var data_tablefile = {
                id: 0,
                tbl_name: "appointment_notice_file",
                tbl_id: this.appointment_id,
                file_type: "",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              if (
                item
                  .split(".")
                  .pop()
                  .toLowerCase() == "pdf"
              ) {
                data_tablefile.file_type = "file";
                this.oldnotifile.push(item);
              } else {
                data_tablefile.file_type = "image";
                this.oldnotiimage.push(item);
              }
              this.FlieArray.push(data_tablefile);
              this.filenamenotice.push(item);
              this.image_listnotice.push(item);
            }
          }
          //   this.oldnotifile = this.getpreview_listnotice;
        }
        if (
          resultappointment.data[0].attachment_files &&
          resultappointment.data[0].attachment_files != ""
        ) {
          this.oldattfile = [];
          this.oldattimage = [];

          let masterImages = resultappointment.data[0].attachment_files;

          // แยกค่าด้วยเครื่องหมายคอมม่า
          let imageArray = masterImages.split(",");

          // ตัดช่องว่างที่หน้าและหลังของแต่ละค่า
          imageArray = imageArray.map((image) => image.trim());

          // ถ้าคุณต้องการลบคอมม่าที่ท้ายสุด ถ้ามี
          if (imageArray[imageArray.length - 1] === "") {
            imageArray.pop(); // ลบค่าว่างที่เกิดจากคอมม่าที่ท้ายสุด
          }

          if (imageArray.length > 0) {
            for (const [index, item] of imageArray.entries()) {
              var data_tableimage = {
                id: 0,
                tbl_name: "appointment_attachment_files",
                tbl_id: this.appointment_id,
                file_type: "",
                file_name: item,
                created_at: "",
                updated_at: "",
                update_date: "-",
              };
              if (
                item
                  .split(".")
                  .pop()
                  .toLowerCase() == "pdf"
              ) {
                data_tableimage.file_type = "file";
                this.oldattfile.push({ name: item });
              } else {
                data_tableimage.file_type = "image";
                this.oldattimage.push({ name: item });
              }

              this.FlieArray.push(data_tableimage);
              this.image_listattach.push({ name: item });
            }
          }
        }

        this.itemdata.trademark_name = resultappointment.data[0].owner_name;
        // if (
        //   resultappointment.data[0].owner_contact &&
        //   resultappointment.data[0].owner_contact != ""
        // ) {
        //   this.itemdata.owner_contact = resultappointment.data[0].owner_contact;
        //   var ownername = resultappointment.data[0].owner_contact;

        //   var listid_owner = ownername.split(",").map((s) => Number(s.trim()));

        //   const matchedContactsOwner = this.contact_owner_list.filter(
        //     (contact) => listid_owner.includes(contact.contact_id)
        //   );

        //   this.itemdata.trademark_name = "";
        //   this.itemdata.trademark_name = matchedContactsOwner
        //     .map((c) => c.contact_name)
        //     .join(", ");
        // } else {
        //   this.itemdata.trademark_name = "";
        //   this.itemdata.owner_contact = "";
        // }

        if (
          resultappointment.data[0].agent_contact &&
          resultappointment.data[0].agent_contact != 0
        ) {
          this.itemdata.agent_contact = resultappointment.data[0].agent_contact;

          this.contact_agent_list.filter((item) => {
            if (item.contact_id == this.itemdata.agent_contact) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
          this.itemdata.agent_contact = 0;
        }

        if (
          resultappointment.data[0].associate_contact &&
          resultappointment.data[0].associate_contact != 0
        ) {
          this.itemdata.associate_contact =
            resultappointment.data[0].associate_contact;
          this.contact_associate_list.filter((item) => {
            if (item.contact_id == this.itemdata.associate_contact) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
          this.itemdata.associate_contact = 0;
        }

        if (Number(this.itemdata.closed) != 3) {
          this.check_closed = true;
        } else {
          this.check_closed = false;
        }
      }
    },
    async loadreceiptfile() {
      var data_search_rc = {
        tbl_name1: "appointment_receipt_files",
        tbl_name2: "appointment_receipt_image",
        tbl_id: Number(this.appointment_id),
      };

      const result_rcfile = await api.getAllFileAtLawFileAp({
        params: data_search_rc,
      });

      this.filenamerecive = [];
      this.image_listrecicpt = [];
      if (result_rcfile.data.length > 0) {
        for (const [index, item] of result_rcfile.data.entries()) {
          this.filenamerecive.push(item.file_name);

          var datarc = {
            name: item.file_name,
          };
          this.image_listrecicpt.push(datarc);
          this.image_listrecicpt_old.push(datarc);
        }
      }
    },
    async loadSoftfile() {
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };

      this.existingFiles = {}; // เก็บไฟล์เก่า
      this.uploadedFiles = {}; // ไฟล์ใหม่
      this.oldFiles = {}; // เก็บชื่อไฟล์เก่าแบบสั้น
      this.oldFilesCheck = {}; // เก็บชื่อไฟล์เก่าแบบสั้น

      const softfileTypes = [
        { key: "Form001", tbl_name: "appointment_softfile_form001" },
        { key: "Descriptions", tbl_name: "appointment_softfile_descriptions" },
        { key: "Claims", tbl_name: "appointment_softfile_claims" },
        { key: "Drawings", tbl_name: "appointment_softfile_drawings" },
        { key: "Abstract", tbl_name: "appointment_softfile_abstract" },
      ];

      for (const type of softfileTypes) {
        const params = {
          tbl_name: type.tbl_name,
          tbl_id: Number(this.appointment_id),
        };

        try {
          const response = await api.getAllFileAtLawFile({ params });

          if (
            response &&
            Array.isArray(response.data) &&
            response.data.length > 0
          ) {
            this.checkboxes[type.key] = true;

            // เก็บข้อมูลไฟล์เก่าทั้งหมด (เป็น array)
            this.existingFiles[type.key] = response.data.map((file) => ({
              name: file.file_name,
              previewUrl: `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${file.file_name}`,
            }));

            // เก็บเฉพาะชื่อไฟล์ (สำหรับส่งกลับ)
            this.oldFiles[type.key] = response.data.map(
              (file) => file.file_name,
            );
            this.oldFilesCheck[type.key] = response.data.map(
              (file) => file.file_name,
            );
          }
        } catch (error) {
          console.error(`Error loading ${type.tbl_name}:`, error);
        }
      }
    },

    calDateAnn() {
      this.itemdata.next_annuity_date = this.formatDate(
        this.data_maserter_pt.next_annuity_date_pt,
      );

      const cal_y =
        Number(this.itemdata.dead_last_annuity_paid) -
        Number(this.data_maserter_pt.dead_last_annuity_paid_pt);

      if (cal_y !== 0) {
        // แปลง next_annuity_date จาก dd/mm/yyyy → Date
        const [day, month, year] = this.itemdata.next_annuity_date
          .split("/")
          .map(Number);
        const nextDate = new Date(year, month - 1, day);

        // เพิ่ม/ลดปีตาม cal_y
        nextDate.setFullYear(nextDate.getFullYear() + cal_y);

        // กำหนดค่ากลับให้ next_annuity_date
        const updatedNextDate = `${nextDate.getFullYear()}-${String(
          nextDate.getMonth() + 1,
        ).padStart(2, "0")}-${String(nextDate.getDate()).padStart(2, "0")}`;
        this.itemdata.next_annuity_date = this.formatDate(updatedNextDate);

        // คำนวณ final_due_date โดยบวก 60 วัน
        const finalDue = new Date(nextDate);
        if (this.showAnnfirst) {
          finalDue.setDate(finalDue.getDate() + 59);
        } else {
          finalDue.setDate(finalDue.getDate() + 60);
        }

        const d = String(finalDue.getDate()).padStart(2, "0");
        const m = String(finalDue.getMonth() + 1).padStart(2, "0");
        const y = finalDue.getFullYear();

        this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
      } else {
        // ไม่ต้องคำนวณใหม่ ใช้ค่าจาก master
        this.itemdata.next_annuity_date = this.formatDate(
          this.data_maserter_pt.next_annuity_date_pt,
        );
        this.itemdata.final_due_date_for_next_payment = this.formatDate(
          this.data_maserter_pt.final_due_date_for_next_payment_pt,
        );
      }

      this.$forceUpdate();
    },
    fileDoctypeInput() {
      // หาว่า id ไหนถูกลบออก
      const removed = this.prev_doctype_actions_select.filter(
        (id) => !this.doctype_actions_select.includes(id),
      );

      // ลบไฟล์ที่เกี่ยวข้อง
      removed.forEach((id) => {
        this.$delete(this.uploadedFilesDoctype, id);
      });

      // อัปเดตค่าก่อนหน้า
      this.prev_doctype_actions_select = [...this.doctype_actions_select];
    },
    async loadDataDotypeAction() {
      const res_doctye_actions = await api.getbyobjectgroup_id(2);
      this.doctype_actions_tlist = res_doctye_actions.data;
    },
    triggerFileInput(key) {
      this.$refs[`fileInput_${key}`][0].click();
    },

    triggerFileInputDoctype(itemId) {
      this.$refs[`fileInput_${itemId}`][0].click();
    },
    handleFileUploadDoctype(event, itemId) {
      const file = event.target.files[0];
      if (file) {
        this.$set(this.uploadedFilesDoctype, itemId, file);
      }
    },
    cancelCheckbox() {
      this.dialogCheckbox = false;
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
      this.uploadedFiles = {};
      this.checkboxes = {
        Form001: false,
        Descriptions: false,
        Claims: false,
        Drawings: false,
        Abstract: false,
      };
    },
    saveSelection() {
      this.dialogCheckbox = false;
    },
    openselectFileWorld() {
      this.dialogCheckbox = true;
    },
    async previewMultiFile(event) {
      // ถ้าอยากล้างไฟล์เดิม uncomment ข้างล่าง
      // this.preview_listnotice = [];
      // this.image_listnotice = [];
      // this.filenamenotice = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          const existingNames = this.filenamenotice;

          // ถ้าชื่อซ้ำ ให้เพิ่ม _1, _2, _3
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.preview_listnotice.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listnotice.push(renamedFile);
          this.filenamenotice.push(name);
        }
      });

      this.checkfilenotice = true;
    },
    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type) {
        if (checkfile.type == "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
               <html>
                <head>
                  <title>Image Preview</title>
                  <style>
                    html, body {
                      margin: 50px 0 0 0;
                      height: 80%;
                      overflow: hidden;
                      background-color: black;
                      display: flex;
                      justify-content: center; /* จัดกลางในแนวนอน */
                      align-items: center; /* จัดกลางในแนวตั้ง */
                    }
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                    }
                  </style>
                </head>
                <body>
                  <img src="${checkfile}" title="Image Preview" />
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        }
      } else {
        if (checkfile.split(/[\s.]+/).pop() == "pdf") {
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(
            `
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `,
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
            <html>
              <head>
                <title>Preview Image</title>
              </head>
              <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                <!-- แสดงภาพที่นี่ -->
                <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
                
              </body>
            </html>
          `);
          return;
        }
      }
    },
    async closepreviewfile() {
      this.dialogpreviewfilenotice = false;
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async previewMultiAttachFile(event) {
      // ❗ ถ้าอยากลบไฟล์เดิมที่เคยอัปโหลด ให้เคลียร์ array
      // this.preview_listattach = [];
      // this.getpreview_listattach = [];
      // this.image_listattach = [];
      this.filenameattach = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        // เฉพาะ PDF และรูปภาพ
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          // รวมชื่อไฟล์ที่มีอยู่แล้วใน image_listattach
          const existingNames = this.image_listattach.map((f) => f.name);

          // ถ้าซ้ำ ให้เพิ่ม _1, _2, ...
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listattach.push(renamedFile);
          this.filenameattach.push(name);
        }
      });

      this.preview_listattach2 = this.preview_listattach;
      this.checkfileattach = true;
    },
    async previewMultiReceipt(event) {
      this.filenamerecive = [];

      const input = event.target;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const files = Array.from(input.files);

      files.forEach((file) => {
        // เฉพาะ PDF และรูปภาพ
        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          let originalName = file.name;
          let name = originalName;
          let counter = 1;

          // ตรวจสอบชื่อซ้ำใน image_listrecicpt
          const existingNames = this.image_listrecicpt.map((f) => f.name);

          // ถ้าชื่อซ้ำให้เพิ่ม -1, -2, ...
          while (existingNames.includes(name)) {
            const dotIndex = originalName.lastIndexOf(".");
            if (dotIndex !== -1) {
              const basename = originalName.substring(0, dotIndex);
              const extension = originalName.substring(dotIndex);
              name = `${basename}-${counter}${extension}`;
            } else {
              name = `${originalName}-${counter}`;
            }
            counter++;
          }

          // สร้างไฟล์ใหม่ชื่อไม่ซ้ำ
          const renamedFile = new File([file], name, { type: file.type });

          // Preview
          const reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_listreceipt.push(e.target.result);
            this.preview_listrecicpt.push(e.target.result);
          };
          reader.readAsDataURL(renamedFile);

          // เก็บไฟล์และชื่อ
          this.image_listrecicpt.push(renamedFile);
          this.filenamerecive.push(name);
        }
      });

      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.checkfileattach = true;
    },

    async previewattachfile(index) {
      let checkfile = this.image_listattach[index];
      if (checkfile.type) {
        if (checkfile.type == "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
              <html>
                <head>
                  <title>PDF Preview</title>
                  <style>
                    html, body {
                      margin: 0;
                      height: 100%;
                      overflow: hidden;
                    }
                    iframe {
                      border: none;
                      width: 100%;
                      height: 100%;
                    }
                  </style>
                </head>
                <body>
                  <iframe src="${checkfile}" title="PDF Preview"></iframe>
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const checkfile = e.target.result;

            let pdf_newTab = window.open("");
            pdf_newTab.document.write(`
               <html>
                <head>
                  <title>Image Preview</title>
                  <style>
                    html, body {
                      margin: 50px 0 0 0;
                      height: 80%;
                      overflow: hidden;
                      background-color: black;
                      display: flex;
                      justify-content: center; /* จัดกลางในแนวนอน */
                      align-items: center; /* จัดกลางในแนวตั้ง */
                    }
                    img {
                      width: 100%;
                      height: 100%;
                      object-fit: contain; /* รูปภาพจะไม่ยืดออก */
                    }
                  </style>
                </head>
                <body>
                  <img src="${checkfile}" title="Image Preview" />
                </body>
              </html>
            `);
            pdf_newTab.document.close();
          };
          reader.readAsDataURL(checkfile);
          return;
        }
      } else {
        if (this.image_listattach[index].name.split(/[\s.]+/).pop() == "pdf") {
          window.open(
            `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${this.image_listattach[index].name}`,
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
            <html>
              <head>
                <title>Preview Image</title>
              </head>
              <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${this.image_listattach[index].name}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
              </body>
            </html>
          `);
          return;
        }
      }
    },
    async previewreceiptfile(index) {
      let checkfile = this.image_listrecicpt[index];
      if (checkfile.type) {
        const fileUrl = URL.createObjectURL(checkfile);
        const extension = checkfile.name
          .split(".")
          .pop()
          .toLowerCase();

        if (extension === "pdf") {
          const pdfWindow = window.open("", "_blank");
          pdfWindow.document.write(`
    <html>
      <head>
        <title>PDF Preview</title>
        <style>
          html, body {
            margin: 0;
            height: 100%;
          }
          iframe {
            border: none;
            width: 100%;
            height: 100%;
          }
        </style>
      </head>
      <body>
        <iframe src="${fileUrl}"></iframe>
      </body>
    </html>
  `);
        } else {
          const imgWindow = window.open("", "_blank");
          imgWindow.document.write(`
    <html>
      <head><title>Image Preview</title></head>
      <body style="margin:0; display:flex; justify-content:center; align-items:center; background:#000; height:100vh;">
        <img src="${fileUrl}" style="max-width:100%; max-height:100%;" />
      </body>
    </html>
  `);
        }
      } else {
        if (checkfile.name.split(/[\s.]+/).pop() == "pdf") {
          window.open(
            `${fileappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile.name}`,
          );
          return;
        } else {
          const imageTab = window.open("");
          imageTab.document.write(`
                    <html>
                    <head>
                        <title>Preview Image</title>
                    </head>
                    <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
                        <img src="${imageappointmentTMUrl}/${this.$route.params.appointment_id}/${checkfile.name}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
                    </body>
                    </html>
                `);
          return;
        }
      }
    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },

    async loaddatafile_no() {
      if (this.$route.params.file_no) {
        this.itemdata.refno = this.$route.params.file_no;
        this.onSearchfile_no(this.itemdata.refno);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      this.objecttype_list = result.data;
    },
    async loaddatadocumentPTtype() {
      const result = await api.getdocumenttype_ptcode();
      this.documenttype_ptlist = result.data;
      this.documenttype_ptlist_search = result.data;
    },
    async onSearchfile_no(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      this.itemdata.refno = this.itemdata.refno.trim().toUpperCase();
      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };
      this.trademark_name = "";
      this.agent_contact_name = "";
      this.associate_contact_name = "";
      const result = await api.getfile_noPT(file_no);

      if (result.data[0]) {
        this.data_maserter_pt = result.data[0];
        const res_priority = await api.getAllMASTERPT_PRIORITY_BYID(
          Number(result.data[0].masterpt_id),
        );
        this.data_maserter_pt_priority = res_priority.data;

        this.titleshow = result.data[0].title;
        this.itemdata.objecttype = result.data[0].tm_type;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest =
          result.data[0].agent_contact_custid != 0
            ? result.data[0].agent_contact_custid
            : result.data[0].owner_contact_custid != 0
            ? result.data[0].owner_contact_custid
            : 0;

        if (
          result.data[0].owner_contact_id &&
          result.data[0].owner_contact_id != ""
        ) {
          this.itemdata.owner_contact = result.data[0].owner_contact_id;
          var ownername = result.data[0].owner_contact_id;
          var listid_owner = ownername.split(",").map((s) => Number(s.trim()));
          const matchedContactsOwner = this.contact_owner_list.filter(
            (contact) => listid_owner.includes(contact.contact_id),
          );
          this.itemdata.trademark_name = "";
          this.itemdata.trademark_name = matchedContactsOwner
            .map((c) => c.contact_name)
            .join(", ");
        } else {
          this.itemdata.trademark_name = "";
        }
        if (
          result.data[0].agent_contact_id &&
          result.data[0].agent_contact_id != 0
        ) {
          this.itemdata.agent_contact = result.data[0].agent_contact_id;

          this.contact_agent_list.filter((item) => {
            if (item.contact_id == this.itemdata.agent_contact) {
              this.agent_contact_name = item.contact_name;
            }
          });
        } else {
          this.agent_contact_name = "";
        }

        if (
          result.data[0].associate_contact_id &&
          result.data[0].associate_contact_id != 0
        ) {
          this.itemdata.associate_contact = result.data[0].associate_contact_id;
          this.contact_associate_list.filter((item) => {
            if (item.contact_id == this.itemdata.associate_contact) {
              this.associate_contact_name = item.contact_name;
            }
          });
        } else {
          this.associate_contact_name = "";
        }
        this.checktypeFunction();
      } else {
        this.data_maserter_pt = [];
        this.itemdata.objecttype = 0;
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    async onSearchfile_nosave(file_no) {
      if (!file_no || file_no.trim() == "") {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        return;
      }
      //alert(file_no);
      const result = await api.getfile_noPT(file_no);
      if (result.data[0]) {
        //alert("hevedata");
        this.titleshow = result.data[0].title;
        this.app_noshow = result.data[0].app_no;
        this.itemdata.trademark_name = result.data[0].name_of_client;
        this.typeshow = result.data[0].type;
        this.customer_id_forpatmentrequest =
          result.data[0].agent_contact_custid != 0
            ? result.data[0].agent_contact_custid
            : result.data[0].owner_contact_custid != 0
            ? result.data[0].owner_contact_custid
            : 0;
      } else {
        this.itemdata.refno = "";
        this.app_noshow = "";
        this.titleshow = "";
        this.itemdata.trademark_name = "";
        this.typeshow = 0;
        this.customer_id_forpatmentrequest = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Search File No. ",
          "File No. not found ",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    checktypeFunction() {
      if (this.itemdata.doctype == 0) return;

      const doctype = this.documenttype_ptlist.find(
        (item) => item.documenttype_id === this.itemdata.doctype,
      );
      if (!doctype) return;

      const code = doctype.documenttype_code;

      const isAnnuity = code.includes("Annuity Fees");
      const isRegistration = code === "Registration & Annuity Fees";

      const isNewFiling = code.includes("New Filing");
      const isNewFilingExact = code === "New Filing";
      const isNewFilingSubDoc = code === "New Filing Sub Doc";

      const isChangeMaster = code.includes("Change Master of Record");
      const isSubstantiveExam = code.includes("Substantive Examination");

      // Default: reset flags
      this.default_col = !isAnnuity && !isNewFiling && !isChangeMaster;
      this.showAnn = false;
      this.showAnnReg = false;
      this.showAnnfirst = false;
      this.showNew = false;
      this.showNewFilingExact = false;
      this.showNewFilingSubdoc = false;
      this.showChage = false;
      this.showSub = false;

      // Clear fields
      this.itemdata.dead_last_annuity_paid = "";
      this.itemdata.last_annuity_paid = null;
      this.itemdata.next_annuity_date = null;
      this.itemdata.new_filling = null;
      this.itemdata.internaldate = null;
      this.itemdata.receive_date = this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      );
      this.receive_date = this.changeformatDatetoinsert(
        this.itemdata.receive_date,
      );
      // this.itemdata.date_of_application = null;

      this.changeMasterRecord = {
        type: false,
        title: false,
        titleInThai: false,
        clientName: false,
        agentReference: false,
        agentName: false,
        associateName: false,
      };

      if (isAnnuity) {
        this.default_col = false;
        this.showAnn = true;
        if (this.data_maserter_pt) {
          this.itemdata.dead_last_annuity_paid = this.data_maserter_pt.dead_last_annuity_paid_pt;
          this.itemdata.last_annuity_paid = this.formatDate(
            this.data_maserter_pt.last_annuity_paid_pt,
          );
          this.itemdata.next_annuity_date = this.formatDate(
            this.data_maserter_pt.next_annuity_date_pt,
          );
          this.itemdata.final_due_date_for_next_payment = this.formatDate(
            this.data_maserter_pt.final_due_date_for_next_payment_pt,
          );
        }
        if (isRegistration) {
          this.showAnnReg = true;
          this.default_col = true;
        } else {
          this.showAnnfirst = true;
        }
      }

      if (isNewFiling) {
        this.itemdata.enddate = null;
        this.showNew = true;
        this.default_col = false;

        const sorted = [...this.data_maserter_pt_priority].sort(
          (a, b) => new Date(a.priority_date) - new Date(b.priority_date),
        );
        const oldest = sorted[0]?.priority_date;
        if (oldest) {
          const [y, m, d] = oldest.split("-").map(Number);
          const date = new Date(y, m - 1, d);

          if (this.data_maserter_pt.sub_type === "PARIS")
            date.setMonth(date.getMonth() + 12);
          if (this.data_maserter_pt.sub_type === "PCT")
            date.setMonth(date.getMonth() + 30);

          this.itemdata.new_filling = `${String(date.getDate()).padStart(
            2,
            "0",
          )}/${String(date.getMonth() + 1).padStart(
            2,
            "0",
          )}/${date.getFullYear()}`;
        }
        if (isNewFilingExact) {
          this.showNewFilingExact = true;
          this.itemdata.date_of_application = this.formatDate(
            this.data_maserter_pt.date_of_application,
          );
          this.itemdata.app_no = this.data_maserter_pt.app_no;
          this.date_of_application = this.data_maserter_pt.date_of_application;
        } else if (isNewFilingSubDoc) {
          this.showNewFilingSubdoc = true;
          this.default_col = true;
          if (this.data_maserter_pt.date_of_application) {
            this.itemdata.receive_date = this.formatDate(
              this.data_maserter_pt.date_of_application,
            );
            this.receive_date = this.data_maserter_pt.date_of_application;

            this.calDateFinalDeadline();
          } else {
            this.itemdata.receive_date = null;
          }
        } else {
          return;
        }
      }

      if (isChangeMaster) {
        this.showChage = true;
        this.default_col = false;
        this.default_type = false; // ✅ ตั้งค่า default_type ที่นี่เท่านั้น
      } else {
        this.default_type = true; // ✅ ถ้าไม่ใช่ Change Master ให้เป็น true
      }

      // No need to do anything for isSubstantiveExam – fields already cleared
      if (isSubstantiveExam) {
        this.showSub = true;
        if (this.data_maserter_pt.date_of_application) {
          this.itemdata.receive_date = this.formatDate(
            this.data_maserter_pt.date_of_publishing,
          );
          this.receive_date = this.data_maserter_pt.date_of_publishing;

          this.itemdata.enddate = this.formatDate(
            this.data_maserter_pt.exam_request_deadline,
          );
          this.enddate = this.data_maserter_pt.exam_request_deadline;

          this.enddate = this.data_maserter_pt.exam_request_deadline;

          if (this.enddate) {
            let d = new Date(this.enddate); // แปลง string → Date
            d.setDate(d.getDate() + 60); // บวก 60 วัน
            this.itemdata.internaldate = this.formatDate(
              d.toISOString().split("T")[0],
            ); // คืนค่าเป็น YYYY-MM-DD
            this.internaldate = d.toISOString().split("T")[0]; // คืนค่าเป็น YYYY-MM-DD
          } else {
            this.itemdata.internaldate = null;
          }

          // this.calDateFinalDeadline()
        } else {
          this.itemdata.receive_date = null;
        }
        // this.itemdata.receive_date = null;
        // this.itemdata.enddate = null;
        // this.itemdata.internaldate = null;
      } else {
        if (!isNewFiling && !isSubstantiveExam) {
          this.itemdata.receive_date = this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10),
          );
          this.calDateFinalDeadline();
        }
      }
      this.$forceUpdate();
    },
    calDateFinalDeadline() {
      if (this.itemdata.doctype != 0 && this.itemdata.doctype) {
        if (this.showSub) {
          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setFullYear(date.getFullYear() + 5);
          date.setDate(date.getDate() - 1);

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${d}/${m}/${y}`;

          const internalDate = new Date(date);
          const originalDay = internalDate.getDate();
          internalDate.setMonth(internalDate.getMonth() - 6);
          if (internalDate.getDate() < originalDay) {
            internalDate.setDate(0);
          }

          const iy = internalDate.getFullYear();
          const im = String(internalDate.getMonth() + 1).padStart(2, "0");
          const id = String(internalDate.getDate()).padStart(2, "0");
          this.itemdata.internaldate = `${id}/${im}/${iy}`;
        } else {
          const dataItem = this.documenttype_ptlist.find(
            (item) => item.documenttype_id === this.itemdata.doctype,
          );

          const dateplus = dataItem?.numberofenddate
            ? dataItem.numberofenddate - 1
            : 0;

          const [year, month, day] = this.receive_date.split("-").map(Number);
          const date = new Date(year, month - 1, day);
          date.setDate(date.getDate() + dateplus);

          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          this.itemdata.enddate = `${dd}/${mm}/${yyyy}`;

          const internalDate = new Date(date);
          internalDate.setDate(internalDate.getDate() - 7);

          const idd = String(internalDate.getDate()).padStart(2, "0");
          const imm = String(internalDate.getMonth() + 1).padStart(2, "0");
          const iyyyy = internalDate.getFullYear();
          this.itemdata.internaldate = `${idd}/${imm}/${iyyyy}`;
        }
      }
    },

    async saveItem(mode) {
      var dataset = [];
      if (this.itemdata.objecttype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put Object Type ",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.itemdata.doctype == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.itemdata.refno == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put File NO ",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (mode == "paymentrequest") {
        const checkMaterPT = await api.getfile_noPTPayment(this.itemdata.refno);
        if (checkMaterPT.data.length > 0) {
          dataset = checkMaterPT.data[0];

          if (!dataset.cus_billing_id || dataset.cus_billing_id == "") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data ",
              "Please verify the customer's billing details.",
              "text-h5 red--text text-center",
            );
            return;
          }

          // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าที่ผูกกับแฟ้มนี้
          if (this.formQutations.salesOrderId) {
            const selectedSO = this.salesOrderList.find(
              (item) =>
                Number(item.quotation_id) ===
                Number(this.formQutations.salesOrderId),
            );

            if (!selectedSO) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Check data",
                "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
                "text-h5 red--text text-center",
              );
              return;
            }

            if (
              Number(selectedSO.client_id) !== Number(dataset.cus_billing_id)
            ) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "ข้อมูลลูกค้าไม่ตรงกัน",
                `ใบเสนอราคา ${
                  selectedSO.doc_no
                } เป็นของลูกค้า "${selectedSO.customer_name ||
                  "-"}" ซึ่งไม่ตรงกับลูกค้าในแฟ้มนี้`,
                "text-h5 red--text text-center",
              );
              return;
            }
          }
        }
      }

      const exists = this.documenttype_ptlist_search.some(
        (item) => item.documenttype_id === this.itemdata.doctype,
      );

      if (!exists) {
        this.itemdata.doctype = 0;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check data ",
          "Put PF Work Type ",
          "text-h5 red--text text-center",
        );
        return;
      }

      // ป้องกัน undefined
      this.oldattfile = this.oldattfile ?? [];
      this.oldattimage = this.oldattimage ?? [];
      this.oldnotifile = this.oldnotifile ?? [];
      this.oldnotiimage = this.oldnotiimage ?? [];
      this.image_listattach = this.image_listattach ?? [];
      this.image_listnotice = this.image_listnotice ?? [];
      this.filenamenotice = this.filenamenotice ?? [];

      let datattF = [];
      let deleteattF = [];
      let dataattI = [];
      let deleteattI = [];

      for (const [index, item] of this.oldattfile.entries()) {
        if (this.image_listattach.some((file) => file.name === item.name)) {
          datattF.push(item.name);
        } else {
          deleteattF.push(item.name);
        }
      }

      for (const [index, item] of this.oldattimage.entries()) {
        if (this.image_listattach.some((file) => file.name === item.name)) {
          dataattI.push(item.name);
        } else {
          deleteattI.push(item.name);
        }
      }

      const dataoldattfile = datattF.join(",");
      const deleteoldattfile = deleteattF.join(",");
      const dataoldattimage = dataattI.join(",");
      const deleteoldattmage = deleteattI.join(",");

      let datanoticF = [];
      let deletedatanoticF = [];
      let datanoticI = [];
      let deletedatanoticI = [];

      for (const item of this.oldnotifile) {
        if (this.filenamenotice.includes(item)) {
          datanoticF.push(item);
        } else {
          deletedatanoticF.push(item);
        }
      }

      for (const item of this.oldnotiimage) {
        if (this.filenamenotice.includes(item)) {
          datanoticI.push(item);
        } else {
          deletedatanoticI.push(item);
        }
      }

      const dataoldnotifile = datanoticF.join(",");
      const deleteoldnotifile = deletedatanoticF.join(",");
      const dataoldnotiimage = datanoticI.join(",");
      const deleteoldnotiimage = deletedatanoticI.join(",");

      let datanotiall = "";
      const datachekcut = [...datanoticF, ...datanoticI];
      if (datachekcut.length > 0) {
        const datanotialllist = this.filenamenotice.filter(
          (item) => !datachekcut.includes(item),
        );
        datanotiall = datanotialllist.join(",");
      } else {
        datanotiall = this.filenamenotice.join(",");
      }

      const checkfile_noPT = await api.getfile_noPT(this.itemdata.refno);

      if (!checkfile_noPT.data[0]) {
        this.clearForm();
        this.setupAlertDialog(
          true,
          "Search File No.",
          "File No. not found",
          "text-h5 red--text text-center",
        );
        return;
      }

      let formData = new FormData();

      this.image_listnotice.forEach((item) => {
        if (item?.type) formData.append("file", item);
      });
      this.image_listattach.forEach((item) => {
        if (item?.type) formData.append("file", item);
      });

      formData.append("datanotiall", datanotiall);
      formData.append("datanotiold", dataoldnotifile);
      formData.append("dataoldnotiimage", dataoldnotiimage);
      formData.append("deleteoldnotifile", deleteoldnotifile);
      formData.append("deleteoldnotiimage", deleteoldnotiimage);
      formData.append("dataoldattfile", dataoldattfile);
      formData.append("dataoldattimage", dataoldattimage);
      formData.append("deleteoldattfile", deleteoldattfile);
      formData.append("deleteoldattmages", deleteoldattmage);
      formData.append("notice_file", "");
      formData.append("attachment_files", "");
      formData.append(`quotation_id`, Number(this.formQutations.salesOrderId));
      if (mode === "paymentrequest") this.itemdata.paymentrequest = 1;

      formData.append("paymentrequest", this.itemdata.paymentrequest);
      formData.append("objecttype", this.itemdata.objecttype);
      formData.append("doctype", this.itemdata.doctype);
      formData.append("sourcetype", this.itemdata.sourcetype);
      formData.append("trademark_name", ``);
      formData.append("owner_name", this.itemdata.trademark_name);
      formData.append("refno", this.itemdata.refno.trim());
      formData.append("categories", this.itemdata.categories.trim());
      formData.append("description", this.itemdata.description.trim());
      formData.append("remark", this.itemdata.remark);
      formData.append(
        "receive_date",
        this.changeformatDatetoinsert(this.itemdata.receive_date),
      );
      formData.append(
        "startdate",
        this.changeformatDatetoinsert(this.itemdata.startdate),
      );
      formData.append(
        "enddate",
        this.changeformatDatetoinsert(this.itemdata.enddate),
      );
      formData.append(
        "internaldate",
        this.changeformatDatetoinsert(this.itemdata.internaldate),
      );
      formData.append(
        `update_by`,
        Number(localStorage.getItem(server.USER_ID)),
      );
      formData.append(`owner_contact`, this.itemdata.owner_contact);
      formData.append(`agent_contact`, this.itemdata.agent_contact);
      formData.append(`associate_contact`, this.itemdata.associate_contact);
      formData.append(
        `filling_date`,
        this.changeformatDatetoinsert(this.itemdata.filling_date),
      );

      formData.append("documenttype_action_id", "");
      formData.append("cert", this.itemdata.cert);
      formData.append("report", this.itemdata.report);
      formData.append("done", this.itemdata.done);
      formData.append("closed", this.itemdata.closed);

      formData.append("nextdeadlineninety", 0);
      formData.append("nextdeadlinesixty", 0);
      if (this.showSub) {
        formData.append("check_sub", true);
      } else {
        formData.append("check_sub", false);
      }
      if (this.showAnn) {
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid || "",
        );
        formData.append(
          "last_annuity_paid",
          this.changeformatDatetoinsert(this.itemdata.last_annuity_paid) || "",
        );
        formData.append(
          "next_annuity_date",
          this.changeformatDatetoinsert(this.itemdata.next_annuity_date) || "",
        );
        formData.append(
          "final_due_date_for_next_payment",
          this.changeformatDatetoinsert(
            this.itemdata.final_due_date_for_next_payment,
          ) || "",
        );
        formData.append("check_doc", true);

        if (this.showAnnReg) {
          formData.set(
            `filling_date`,
            this.changeformatDatetoinsert(this.itemdata.filling_date),
          );
          formData.set(
            `receive_date`,
            this.changeformatDatetoinsert(this.itemdata.receive_date),
          );
          formData.set(
            `startdate`,
            this.changeformatDatetoinsert(this.itemdata.startdate),
          );
          formData.set(
            `enddate`,
            this.changeformatDatetoinsert(this.itemdata.enddate),
          );
          formData.set(
            `internaldate`,
            this.changeformatDatetoinsert(this.itemdata.internaldate),
          );
        } else {
          formData.set("filling_date", null);
          formData.set("receive_date", null);
          formData.set("startdate", null);
          formData.set(
            "enddate",
            this.changeformatDatetoinsert(this.itemdata.next_annuity_date) ||
              null,
          );
          formData.set("internaldate", null);
        }
      } else {
        formData.append("dead_last_annuity_paid", "");
        formData.append("last_annuity_paid", "");
        formData.append("next_annuity_date", "");
        formData.append("final_due_date_for_next_payment", "");
        formData.append("check_doc", false);
      }

      if (this.showNew) {
        formData.append(
          "new_filling",
          this.changeformatDatetoinsert(this.itemdata.new_filling) || "",
        );
        formData.set("filling_date", null);
        formData.set("receive_date", null);
        formData.set("startdate", null);

        if (this.showNewFilingExact) {
          formData.set("newfilingECheck", true);
          formData.set("app_no", this.itemdata.app_no);
          formData.set(
            "date_of_application",
            this.changeformatDatetoinsert(this.itemdata.date_of_application) ||
              null,
          );
          formData.set(
            "enddate",
            this.changeformatDatetoinsert(this.itemdata.enddate) || null,
          );
        } else {
          formData.set("date_of_application", null);
          formData.set("newfilingECheck", false);
          formData.set("app_no", "");

          formData.set(
            "filling_date",
            this.changeformatDatetoinsert(this.itemdata.filling_date) || null,
          );
          formData.set(
            "receive_date",
            this.changeformatDatetoinsert(this.itemdata.receive_date) || null,
          );
          formData.set(
            "startdate",
            this.changeformatDatetoinsert(this.itemdata.startdate) || null,
          );
        }
      } else {
        formData.set("newfilingECheck", false);
        formData.set("app_no", "");
        formData.set("date_of_application", null);
      }
      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }
      this.$showLoader();
      const resultAppointment = await api.AppointmentUpdateV2(
        this.appointment_id,
        formData,
      );

      if (
        resultAppointment.status === 200 ||
        resultAppointment.status === 201
      ) {
        try {
          if (this.quotationscheckstatus == "Submitted") {
            var dataupdateStatus = {
              status: "InProgress",
            };
            await api.updateQuotationsCore(
              Number(this.formQutations.salesOrderId),
              dataupdateStatus,
            );
          }
        } catch (quotationsError) {
          console.log(quotationsError);
        }

        var dataadd_timeline = {
          timeline_status_id: Number(this.timelineStatus),
          case_id: Number(this.$route.params.appointment_id),
          module_name: "Patent Docket",
          case_woker: Number(localStorage.getItem(server.USER_ID)),
          status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          status_note: this.status_note.trim(),
          visibility: this.visible_check,
        };
        const result_add = await api.creategetClientTimelineHistory(
          dataadd_timeline,
        );
        try {
          const caseDetailResult = await api.getgetTimelineDataDetail({
            params: {
              module_name: this.module_name,
              case_id: Number(this.$route.params.appointment_id),
            },
          });
          const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

          const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility(
            {
              params: {
                module_name: this.module_name,
                case_id: Number(this.$route.params.appointment_id),
              },
            },
          );
          const timelineData = visibilityResult.data || [];

          caseInfo.status = timelineData[0]?.status || "";
          caseInfo.lastUpdated = timelineData[0]?.status_time || "";

          const latestUpdate = {
            message: timelineData[0]?.status_note || "",
            date: timelineData[0]?.status_time || "",
          };

          await PDFCaseProgress.createToPDF(
            {
              caseInfo,
              latestUpdate,
              timelineData,
              caseId: Number(this.$route.params.appointment_id),
              moduleName: this.module_name,
            },
            { open: false },
          );
        } catch (pdfError) {
          console.error("PDF generation/upload failed:", pdfError);
          // Not re-thrown — the appointment/timeline entry was already updated;
          // a PDF failure here shouldn't block the rest of saveItem (doctype
          // actions diff, change-master-record update, receipt files, soft
          // files, transaction log, etc. that follow).
        }

        if (this.doctype_actions_select.length > 0) {
          const newValues = this.doctype_actions_select;
          const oldValues = this.doctype_actions_select_old;

          // ค่าใหม่ที่เพิ่มมา
          const added = newValues.filter((x) => !oldValues.includes(x));

          // ค่าเก่าที่ถูกลบออกไป
          const removed = oldValues.filter((x) => !newValues.includes(x));

          for (const item of removed) {
            var dataDelete = {
              documenttype_action_id: Number(item),
              appointment_id: Number(this.$route.params.appointment_id),
              appointment_type: `Patent`,
            };
            console.log(dataDelete);
            await api.deleteAppointmentDoctypeActionsByID({
              params: dataDelete,
            });
          }
          for (const [index, item] of added.entries()) {
            var dataAdd = {
              documenttype_action_id: item,
              appointment_id: this.$route.params.appointment_id,
              appointment_type: `Patent`,
              documenttype_follow: 0,
            };
            await api.createAppointmentDoctypeActions(dataAdd);
          }
        } else {
          await api.deleteAppointmentDoctypeActions(
            this.$route.params.appointment_id,
          );
        }

        var dataaddchangeMasterRecord = this.changeMasterRecord;
        dataaddchangeMasterRecord.appointment_id = this.$route.params.appointment_id;
        dataaddchangeMasterRecord.update_by = Number(
          localStorage.getItem(server.USER_ID),
        );
        await api.updateCHAGE_MASTER_RECORD(
          this.$route.params.appointment_id,
          dataaddchangeMasterRecord,
        );

        ///receipt
        const newImages = this.image_listrecicpt.filter(
          (newItem) =>
            !this.image_listrecicpt_old.some(
              (oldItem) => oldItem.name === newItem.name,
            ),
        );
        const newImageNames =
          Array.isArray(this.image_listrecicpt) &&
          Array.isArray(this.image_listrecicpt_old)
            ? this.image_listrecicpt
                .filter(
                  (newItem) =>
                    !this.image_listrecicpt_old.some(
                      (oldItem) => oldItem.name === newItem.name,
                    ),
                )
                .map((item) => item.name)
                .join(",")
            : "";

        const deleteImageNames =
          Array.isArray(this.image_listrecicpt) &&
          Array.isArray(this.image_listrecicpt_old)
            ? this.image_listrecicpt_old
                .filter(
                  (oldItem) =>
                    !this.image_listrecicpt.some(
                      (newItem) => newItem.name === oldItem.name,
                    ),
                )
                .map((item) => item.name)
                .join(",")
            : "";

        let formDataRc = new FormData();

        newImages.forEach((item) => {
          formDataRc.append("file", item);
        });
        formDataRc.append("newImageNames", newImageNames);
        formDataRc.append("deleteImageNames", deleteImageNames);
        await api.updateRecieptfile(this.appointment_id, formDataRc);

        //soft

        let formDataSoft = new FormData();

        // === 1. เพิ่มไฟล์ใหม่ ===
        for (const [key, files] of Object.entries(this.uploadedFiles)) {
          if (Array.isArray(files)) {
            files.forEach((file) => formDataSoft.append("file", file)); // แนบไฟล์จริง
            formDataSoft.append(key, files.map((f) => f.name).join(",")); // แนบชื่อไฟล์
          } else if (files) {
            formDataSoft.append("file", files);
            formDataSoft.append(key, files.name);
          }
        }

        // === 2. หาไฟล์ที่ถูกลบ ===
        const getDeletedFilesGrouped = (oldFiles, existingFiles) => {
          const grouped = {};
          for (const key in oldFiles) {
            const oldList = Array.isArray(oldFiles[key]) ? oldFiles[key] : [];
            const existingList = Array.isArray(existingFiles[key])
              ? existingFiles[key].map((f) => f.name)
              : [];
            const removed = oldList.filter(
              (name) => !existingList.includes(name),
            );
            if (removed.length) {
              grouped[`del${key}`] = removed.join(","); // เช่น delForm001: "file1.docx,file2.docx"
            }
          }
          return grouped;
        };

        const deletedFilesGrouped = getDeletedFilesGrouped(
          this.oldFilesCheck,
          this.existingFiles,
        );

        // === 3. แนบชื่อไฟล์ที่จะลบลง FormData ===
        for (const [key, value] of Object.entries(deletedFilesGrouped)) {
          formDataSoft.append(key, value);
        }

        // === 4. เรียก API ===
        await api.updateSoftfile(
          this.$route.params.appointment_id,
          formDataSoft,
        );

        //end

        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Update",
          table_name: "appointment",
          table_id: this.$route.params.appointment_id,
          date: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLogCoreApi(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog,
        );

        this.$hideLoader();
        if (mode == "paymentrequest") {
          var dataPush = {
            customer_name_master: dataset.cus_name,
            yourRef: "",
            ourRef: "",
            docketId: this.$route.params.appointment_id,
            quotation_id: Number(this.formQutations.salesOrderId),
          };

          var custonerId = 0;
          custonerId = Number(dataset.cus_billing_id);
          const hasThai = /[\u0E00-\u0E7F]/;

          if (hasThai.test(dataset.cus_name)) {
            dataPush.yourRef = `เลขที่อ้างอิงของลูกค้า: ${dataset.client_ref}`;
            dataPush.ourRef = `เลขที่อ้างอิงของบริษัท: ${dataset.file_no}`;
          } else {
            dataPush.yourRef = `Your Ref: ${dataset.client_ref}`;
            dataPush.ourRef = `Our Ref: ${dataset.file_no}`;
          }
          if (dataset.client_ref.trim() == "") {
            dataPush.yourRef = "";
          }
          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${custonerId}/Docket`,
            query: dataPush,
          });
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          localStorage.setItem(server.MODELMENU, 6);
          this.setupAlertDialogPush(
            true,
            "save data",
            "save data success",
            "text-h5 green--text text-center",
            "/appointment-patent-list",
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center",
        );
      }
    },

    // ฟังก์ชันเสริมเพื่อให้โค้ดหลักสะอาด

    showAlert(msg) {
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Check data",
        msg,
        "text-h5 red--text text-center",
      );
    },
    async saveLog() {
      const now = moment()
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:ss");

      await api.addTransectionLog({
        user_id: localStorage.getItem(server.USER_ID),
        log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        action: "Update",
        table_name: "appointment",
        table_id: this.$route.params.appointment_id,
        date: now,
      });

      await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID), {
        last_update: now,
      });
    },
    clearForm() {
      this.itemdata.objecttype = 0;
      this.itemdata.refno = "";
      this.app_noshow = "";
      this.titleshow = "";
      this.itemdata.trademark_name = "";
      this.typeshow = 0;
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async setupAlertDialogPushpaymentIM(
      status,
      title,
      message,
      text_color,
      link,
      querydata,
    ) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
      this.querydata = querydata;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
  watch: {
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application,
      );
    },
    receive_date(val) {
      this.itemdata.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.itemdata.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.itemdata.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.itemdata.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.itemdata.internaldate = this.formatDate(this.internaldate);
    },
    new_filling(val) {
      this.itemdata.new_filling = this.formatDate(this.new_filling);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment,
      );
    },
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  min-height: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.heightsize90formadvance {
  height: 90px;
}

.heightsizesearch {
  height: 45%;
}

h3 {
  font-size: 1.17em;
}

.widthbtnnoticefile {
  width: 100%;
}

.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}

.bt-add {
  color: #1d88ac;
}

.mth {
  margin-top: -20px;
}

a.download-link {
  color: #1d88ac;
  text-decoration: none;
  transition: color 0.3s ease;
}

a.download-link:hover {
  color: #005580;
  /* สีเวลาชี้เมาส์ เปลี่ยนเป็นสีที่ต้องการ */
  cursor: pointer;
}

.no-resize-textarea textarea {
  resize: none !important;
}

.sec-title {
  font-size: 0.9rem;
  font-weight: 700;
  padding: 10px 16px 6px;
}

.sec-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #1b7a99;
  font-weight: 700;
  margin-bottom: 14px;
}

.sec-label .hint {
  color: #6b7785;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

.invoice-box {
  background: #f7fafc;
  border: 1px solid #d8e6f0;
  border-radius: 8px;
  padding: 16px;
}

.field-label {
  font-size: 12.5px;
  color: #37424f;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 18px;
}

.field-label .hint {
  font-size: 11px;
  color: #6b7785;
}

.field-label .hint.danger {
  color: #c0392b;
}

.field-label .req {
  color: #c0392b;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #c47f00;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: help;
}

.is-locked {
  background-color: #b8e6e2 !important;
  border-color: #b8e6e2 !important;
  color: whitesmoke !important;
  opacity: 1 !important;
  pointer-events: none !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.outstanding-card {
  border-radius: 14px !important;
}

.outstanding-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 28px 8px;
}

.outstanding-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #f8e3c2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.outstanding-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1d2b4f;
}

.outstanding-body {
  padding: 8px 28px 20px;
}

.outstanding-text {
  font-size: 1rem;
  color: #2d3748;
  margin-bottom: 14px;
}

.outstanding-list {
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
}

.outstanding-box {
  display: flex;
  align-items: center;
  gap: 20px;
  background: #fdf3e6;
  border-radius: 10px;
  padding: 16px 24px;
  margin-bottom: 10px;
}

.outstanding-col {
  display: flex;
  flex-direction: column;
}

.outstanding-label {
  font-size: 0.95rem;
  color: #4a5568;
}

.outstanding-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1d2b4f;
}

.outstanding-divider {
  width: 1px;
  align-self: stretch;
  background: #e2d3bf;
}

.outstanding-chip {
  background: #f6d9a8;
  color: #8a5a12;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
}

.outstanding-hint {
  font-size: 0.95rem;
  color: #6b7785;
  margin: 10px 0 0;
}

.outstanding-separator {
  height: 1px;
  background: #e5e7eb;
}

.outstanding-actions {
  display: flex;
  gap: 16px;
  padding: 20px 28px 24px;
}

.btn-back {
  border-color: #1d2b4f !important;
  color: #1d2b4f !important;
  text-transform: none !important;
  border-radius: 8px !important;
  min-width: 170px !important;
}

.btn-continue {
  text-transform: none !important;
  border-radius: 8px !important;
  min-width: 190px !important;
}
</style>
